import { render } from "./DetalharDocumento.vue?vue&type=template&id=761d4892&scoped=true"
import script from "./DetalharDocumento.vue?vue&type=script&lang=js"
export * from "./DetalharDocumento.vue?vue&type=script&lang=js"

import "./DetalharDocumento.vue?vue&type=style&index=0&id=761d4892&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-761d4892"]])

export default __exports__